module.exports = __webpack_public_path__ + "img/example14.297b2966.jpg";